import { useEffect } from "react";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import { LoaderCircle } from "lucide-react";
import { finishedReferencesInfiniteQueryOptions } from "src/react-query/react-query";
import { ReferencesGrid } from "src/components/references/ReferencesGrid";

export const InfiniteReferencesGrid = ({
  categorySlug,
}: {
  categorySlug?: string;
}) => {
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useSuspenseInfiniteQuery(
      finishedReferencesInfiniteQueryOptions({ categorySlug }),
    );

  const references = data.pages.flat();

  const [sentinelRef, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    // Start fetching well before the user reaches the bottom of the grid
    rootMargin: "0px 0px 800px 0px",
  });

  useEffect(() => {
    if (entry?.isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [entry?.isIntersecting, hasNextPage, isFetchingNextPage, fetchNextPage]);

  if (references.length === 0) {
    return <div>Žádné reference nebyly nalezeny</div>;
  }

  return (
    <>
      <ReferencesGrid references={references} />
      {hasNextPage && (
        <div ref={sentinelRef} className={"flex justify-center py-8"}>
          <LoaderCircle className={"text-foreground size-8 animate-spin"} />
        </div>
      )}
    </>
  );
};
